import { render, staticRenderFns } from "./MembershipAffiliations.vue?vue&type=template&id=9a19773a&scoped=true"
import script from "./MembershipAffiliations.vue?vue&type=script&lang=js"
export * from "./MembershipAffiliations.vue?vue&type=script&lang=js"
import style0 from "./MembershipAffiliations.vue?vue&type=style&index=0&id=9a19773a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a19773a",
  null
  
)

export default component.exports